import React from 'react';
import {Link} from 'react-router-dom';
import Logo from 'assets/ActusIcone2025x1024.png';
import './style.css';

const NavbarVisitante = ({ login }) => {
    return (
        <nav className="navbar-visitante">
            <div className="navbar-visitante-container">
                <Link to="/login" className="navbar-visitante-brand">
                    <img src={Logo} alt="Actus Logo" className="navbar-visitante-logo" />
                    <span className="navbar-visitante-name">Actus</span>
                </Link>
                <div className="navbar-visitante-actions">
                    <button className="navbar-visitante-login-btn" onClick={login}>
                        <i className="fas fa-sign-in-alt me-2"></i>
                        Entrar
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default NavbarVisitante;
